import { render, staticRenderFns } from "./TropDeRuches.vue?vue&type=template&id=775e0d8c&"
import script from "./TropDeRuches.vue?vue&type=script&lang=js&"
export * from "./TropDeRuches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports